import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SowChangeRequestTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_REQUEST),
  // The change-order project the SOW change was auto-triggered from. Absent on operator-initiated
  // SOW changes and on rows written before this was recorded — consumers must treat that as unknown.
  changeOrderProjectId: z.number().nullish(),
  // Scopes an abandonment rewind to this SOW change's own cycle. Absent on rows written before
  // this was recorded — that means unknown, so consumers fall back to project scope.
  changeOrderIds: z.array(z.string()).nullish(),
});
